import { render, staticRenderFns } from "./VehicleRenewal.vue?vue&type=template&id=28140d4d"
import script from "./VehicleRenewal.vue?vue&type=script&lang=js"
export * from "./VehicleRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports